import { inject, Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private readonly ngxSpinnerService = inject(NgxSpinnerService);

  private apiCount = 0;



  show() {
    if (this.apiCount === 0) {      
      this.ngxSpinnerService.show();
    }
    this.apiCount++;
  }

  hide() {
    this.apiCount--;
    if (this.apiCount === 0) {
      this.ngxSpinnerService.hide();

    }
  }
}